import React, { useEffect, useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import Loader from "../../components/shared/Loader";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import userPlaceholder from "../../assets/images/placeholder.jpg";
import { updateMeta } from "../../store/actions/metaAction";
import { useDropzone } from "react-dropzone";

const ServicesCreate = () => {
	const auth = useSelector(state => state.auth.user);
	const history = useHistory();
	const [loading, setLoading] = useState(false);
	const [title, setTitle] = useState("");
	const [titleEn, setTitleEn] = useState("");
	const [description, setDescription] = useState("");
	const [descriptionEn, setDescriptionEn] = useState("");
	const [pageContent, setPageContent] = useState("");
	const [pageContentEn, setPageContentEn] = useState("");
	const [picture, setPicture] = useState(userPlaceholder);
	const [featureTitle, setFeatureTitle] = useState("");
	const [featureTitleEn, setFeatureTitleEn] = useState("");
	const [features, setFeatures] = useState([]);
	const [files, setFiles] = useState([]);
	const [catalog, setCatalog] = useState([]);
	const [selectedCatalog, setSelectedCatalog] = useState([]);
	const [imageArray, setImageArray] = useState([]);
	const [mainPicture, setMainPicture] = useState(null);
	const [singleCatalog, setSingleCatalog] = useState(null);
	const [servicesCategories, setServicesCategories] = useState([]);
	const [singleCatalogName, setSingleCatalogName] = useState("");
	const dispatch = useDispatch();

	const [targetServiceCategory, setTargetServiceCategory] = useState(
		servicesCategories?.[0]?.id
	);
	useEffect(() => {
		setTargetServiceCategory(servicesCategories?.[0]?.id);
	}, [dispatch, servicesCategories]);

	let editor = null;

	useEffect(() => {
		onStart();
	}, []);

	useEffect(
		() => () => {
			files.forEach(file => URL.revokeObjectURL(file.preview));
		},
		[files]
	);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "اضافة خدمة جديدة",
				breadcrumb: "الخدمات",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);

		const fetchServicesCategories = async () => {
			axios
				.get(`${process.env.REACT_APP_API_URL}/serviceCategories`, {
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
				})
				.then(function (response) {
					setServicesCategories(response.data.data);
					setLoading(false);
				})
				.catch(function (error) {
					toast.error("خطأ، برجاء المحاولة لاحقا!");
					setLoading(false);
				});
		};
		fetchServicesCategories();
	};

	const handlePicture = id => {
		const fileInput = document.querySelector(id);

		if (!fileInput) {
			console.error(`Element with ID "${id}" not found.`);
			return; // Exit the function early if the element isn't found
		}

		if (fileInput.files && fileInput.files[0]) {
			// Check if files exist and are not empty
			if (id === "#mainPicture") {
				setMainPicture(URL.createObjectURL(fileInput.files[0]));
			} else if (id === "#singleCatalog") {
				setSingleCatalog(URL.createObjectURL(fileInput.files[0]));
				setSingleCatalogName(fileInput.files[0].name);
			} else {
				setPicture(URL.createObjectURL(fileInput.files[0]));
			}
		} else {
			console.warn(`No file selected for ${id}`);
			// Handle the case where no file is selected (optional)
		}
	};

	const pushToInformation = e => {
		e.preventDefault();
		if (featureTitle === "") {
			toast.error("برجاء تعبئة الحقول المطلوبة!");
			return;
		}
		const data = { ar: featureTitle, en: featureTitleEn };
		// features.push(data);
		setFeatures(prev => {
			return [...prev, data];
		});
		setFeatureTitle("");
		setFeatureTitleEn("");
	};
	const handleDeleteFeature = (event, information) => {
		event.preventDefault();
		const arr = features.filter(function (item) {
			return item.ar !== information.ar || item.en !== information.en;
		});
		setFeatures(arr);
	};
	const deleteCatalog = (event, catalog) => {
		event.preventDefault();
		setSingleCatalog(null);
		setSingleCatalogName("");
		setCatalog([]);
		document.getElementById("singleCatalog").value = null;
	};
	const handleSubmit = async e => {
		e.preventDefault();
		const picture = document.querySelector("#picture");
		const mainPicture = document.querySelector("#mainPicture");
		const singleFile = document.querySelector("#singleCatalog");

		if (picture.files[0] && mainPicture.files[0]) {
			try {
				setLoading(true);

				// Upload the first file (picture)
				const pictureData = new FormData();
				pictureData.append("file", picture.files[0]);
				const pictureResponse = await axios.post(
					`${process.env.REACT_APP_API_URL}/upload`,
					pictureData,
					{
						headers: {
							Authorization: `Bearer ${cookie.get("token")}`,
							Accept: "application/json",
							"Content-Type": "multipart/form-data",
						},
					}
				);

				// Upload the second file (mainPicture)
				const mainPictureData = new FormData();
				mainPictureData.append("file", mainPicture.files[0]);
				const mainPictureResponse = await axios.post(
					`${process.env.REACT_APP_API_URL}/upload`,
					mainPictureData,
					{
						headers: {
							Authorization: `Bearer ${cookie.get("token")}`,
							Accept: "application/json",
							"Content-Type": "multipart/form-data",
						},
					}
				);

				// Upload the single file
				if (singleFile.files[0]) {
					const singleFileData = new FormData();
					singleFileData.append("file", singleFile.files[0]);
					var singleFileResponse = await axios.post(
						`${process.env.REACT_APP_API_URL}/upload`,
						singleFileData,
						{
							headers: {
								Authorization: `Bearer ${cookie.get("token")}`,
								Accept: "application/json",
								"Content-Type": "multipart/form-data",
							},
						}
					);
				}

				// Once both uploads are successful, create the main data object with their file names
				const data = {
					title: { ar: title, en: titleEn },
					description: { ar: description, en: descriptionEn },
					icon: pictureResponse.data.data.name, // First file name
					image: mainPictureResponse.data.data.name, // Second file name
					page_content: { ar: pageContent, en: pageContentEn },
					features: features,
					catalogName: singleCatalogName,
					catalog: singleFileResponse,
					service_category_id: targetServiceCategory,
				};

				// Submit the main request with data
				await axios.post(
					`${process.env.REACT_APP_API_URL}/posts`,
					{
						category_id: 3,
						admin_id: auth.id,
						data: data,
					},
					{
						headers: {
							Authorization: `Bearer ${cookie.get("token")}`,
							Accept: "application/json",
						},
					}
				);

				history.push("/services/index");
				toast.success("تم اضافة الخدمة بنجاح!");
			} catch (error) {
				toast.error("خطأ، برجاء المحاولة مره اخرى!");
			} finally {
				setLoading(false);
			}
		} else {
			toast.error("برجاء اختيار الصورة أولا!");
		}
	};

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit}>
				<div className="row">
					<div className="col-md-9">
						<div className="card">
							<div className="card-body">
								<div className="row">
									<div className="form-item col-md-6">
										<label htmlFor="title">العنوان</label>
										<input
											type="text"
											id="title"
											required
											value={title}
											onChange={e => setTitle(e.target.value)}
										/>
									</div>
									<div className="form-item col-md-6">
										<label htmlFor="titleEn">العنوان الانجليزي</label>
										<input
											type="text"
											id="titleEn"
											required
											dir="ltr"
											value={titleEn}
											onChange={e => setTitleEn(e.target.value)}
										/>
									</div>
								</div>
								<div className="row">
									<div className="form-item col-md-6">
										<label htmlFor="description">الوصف</label>
										<input
											type="text"
											id="description"
											required
											onChange={e => setDescription(e.target.value)}
										/>
									</div>
									<div className="form-item col-md-6">
										<label htmlFor="descriptionEn"> الوصف الانجليزي</label>
										<input
											type="text"
											id="descriptionEn"
											required
											dir="ltr"
											value={descriptionEn}
											onChange={e => setDescriptionEn(e.target.value)}
										/>
									</div>
								</div>
								<div className="row">
									<div className="form-item  col-md-6">
										<label htmlFor="description">تصنيف الخدمة</label>
										<select
											onChange={e => setTargetServiceCategory(e.target.value)}
											value={targetServiceCategory}
										>
											{servicesCategories?.map((item, index) => (
												<option key={index} value={item?.id}>
													{item?.name?.ar}
												</option>
											))}
										</select>
									</div>
								</div>
								<div className="form-item">
									<label htmlFor="pageContent">النص</label>
									<CKEditor
										onReady={editor => {
											editor.ui
												.getEditableElement()
												.parentElement.insertBefore(
													editor.ui.view.toolbar.element,
													editor.ui.getEditableElement()
												);
											editor = editor;
										}}
										onError={({ willEditorRestart }) => {
											if (willEditorRestart) {
												editor.ui.view.toolbar.element.remove();
											}
										}}
										onChange={(event, editor) => {
											const data = editor.getData();
											setPageContent(data);
										}}
										editor={DecoupledEditor}
										config={{
											contentsLangDirection: "rtl",
											language: "ar",
											extraPlugins: [MyCustomUploadAdapterPlugin],
										}}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="pageContent">النص الانجليزي</label>
									<CKEditor
										data={pageContentEn}
										onReady={editor => {
											editor.ui
												.getEditableElement()
												.parentElement.insertBefore(
													editor.ui.view.toolbar.element,
													editor.ui.getEditableElement()
												);
											editor = editor;
										}}
										onError={({ willEditorRestart }) => {
											if (willEditorRestart) {
												editor.ui.view.toolbar.element.remove();
											}
										}}
										onChange={(event, editor) => {
											const data = editor.getData();
											setPageContentEn(data);
										}}
										editor={DecoupledEditor}
										config={{
											contentsLangDirection: "ltr",
											language: "en",
											extraPlugins: [MyCustomUploadAdapterPlugin],
										}}
									/>
								</div>
								{/* <div className="dropzoneContainer">
									<div {...getRootProps({ className: "dropzone" })}>
										<input {...getInputProps()} />
										<p>اضغط هنا لرفع الصورة الداخلية</p>
									</div>
									<aside className="thumbsContainer">
										{files?.map(file => (
											<div className="thumb" key={file.name}>
												<div className="thumbInner">
													<img src={file.preview} className="img" />
												</div>
											</div>
										))}
									</aside>
									<button
										onClick={handleImageUpload}
										type="button"
										className="bt bt-success"
									>
										رفع الصورة
									</button>
								</div>
								<div className="row">
									{imageArray.map(img => (
										<div className="col-md-2" key={img}>
											<div className="image-preview">
												<img
													src={`${process.env.REACT_APP_MAIN_URL}${img}`}
													alt={img}
													className="imgList"
												/>
												<button onClick={e => deleteImage(e, img)}>
													<i className="fas fa-trash"></i>
												</button>
											</div>
										</div>
									))}
								</div> */}

								<div className="form-item">
									<label htmlFor="mainPicture">الصوره</label>
									<input
										type="file"
										onChange={() => handlePicture("#mainPicture")}
										id="mainPicture"
									/>
									{mainPicture && (
										<div className="img-holder">
											<img
												src={`${mainPicture}`}
												alt="avatar"
												className="imagePreview"
											/>
										</div>
									)}
								</div>

								<div className="form-item">
									<label htmlFor="singleCatalog">الكتالوج</label>
									<input
										type="file"
										onChange={() => handlePicture("#singleCatalog")}
										id="singleCatalog"
									/>
									{singleCatalog && (
										<div className="img-holder d-flex justify-content-between ">
											<div className="catalog  my-3">
												<i className="fas fa-file-alt" /> {singleCatalogName}
											</div>
											<button onClick={e => deleteCatalog(e)}>
												<i className="fas fa-trash" />
											</button>
										</div>
									)}
								</div>
								<br />
								<hr />
								<div className="row">
									<div className="form-item col-md-6">
										<label htmlFor="question">عنوان الميزة</label>
										<input
											type="text"
											id="question"
											value={featureTitle}
											onChange={e => setFeatureTitle(e.target.value)}
										/>
									</div>
									<div className="form-item col-md-6">
										<label htmlFor="questionen"> (الانجليزي)عنوان الميزة</label>
										<input
											type="text"
											id="questionen"
											dir="ltr"
											value={featureTitleEn}
											onChange={e => setFeatureTitleEn(e.target.value)}
										/>
									</div>
								</div>
								<div className="form-item" />
								<button className="bt bt-success" onClick={pushToInformation}>
									اضافة الميزة
								</button>
								<div className="form-item" style={{ marginTop: "40px" }}>
									<ul className="list-unstyled pointList">
										{features.map(feature => (
											<li
												key={feature.title}
												className="d-flex justify-content-between w-100"
											>
												<button onClick={e => handleDeleteFeature(e, feature)}>
													<i className="fas fa-trash" />
												</button>
												<div className="point  row  w-100">
													<span className="col-md-6">عربي : {feature.ar}</span>
													<span className="col-md-6">
														{" "}
														الانجليزي : {feature.en}
													</span>
												</div>
											</li>
										))}
									</ul>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-3">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<input
										type="file"
										onChange={() => handlePicture("#picture")}
										id="picture"
									/>
									{picture && (
										<div className="img-holder">
											<img
												src={`${picture}`}
												alt="avatar"
												className="imagePreview"
											/>
										</div>
									)}
								</div>
							</div>
						</div>
						<div className="form-item mt-3">
							<button className="bt bt-success btn-block">ارسال</button>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

function MyCustomUploadAdapterPlugin(editor) {
	editor.plugins.get("FileRepository").createUploadAdapter = loader => {
		return new MyUploadAdapter(loader);
	};
}

class MyUploadAdapter {
	constructor(props) {
		this.loader = props;
		this.url = `${process.env.REACT_APP_API_URL}/upload`;
	}

	upload() {
		return new Promise((resolve, reject) => {
			this._initRequest();
			this._initListeners(resolve, reject);
			this._sendRequest();
		});
	}

	abort() {
		if (this.xhr) {
			this.xhr.abort();
		}
	}

	_initRequest() {
		const xhr = (this.xhr = new XMLHttpRequest());

		xhr.open("POST", this.url, true);
		xhr.responseType = "json";
		xhr.setRequestHeader("Authorization", `Bearer ${cookie.get("token")}`);
	}

	_initListeners(resolve, reject) {
		const xhr = this.xhr;
		const loader = this.loader;
		const genericErrorText = "Couldn't upload file:" + ` ${loader.file.name}.`;

		xhr.addEventListener("error", () => reject(genericErrorText));
		xhr.addEventListener("abort", () => reject());
		xhr.addEventListener("load", () => {
			const response = xhr.response;
			if (!response || response.error) {
				return reject(
					response && response.error ? response.error.message : genericErrorText
				);
			}
			resolve({
				default: response.data.filePath,
			});
		});

		if (xhr.upload) {
			xhr.upload.addEventListener("progress", evt => {
				if (evt.lengthComputable) {
					loader.uploadTotal = evt.total;
					loader.uploaded = evt.loaded;
				}
			});
		}
	}

	_sendRequest() {
		const data = new FormData();
		this.loader.file.then(result => {
			data.append("file", result);
			this.xhr.send(data);
		});
	}
}

export default ServicesCreate;
